module.exports = __webpack_public_path__ + "assets/images/project/philippines-desktop.jpg?v=6dc93d7a";